import { render, staticRenderFns } from "./ExpandedItem.vue?vue&type=template&id=147a1d92&scoped=true&"
import script from "./ExpandedItem.vue?vue&type=script&lang=ts&"
export * from "./ExpandedItem.vue?vue&type=script&lang=ts&"
import style0 from "./ExpandedItem.vue?vue&type=style&index=0&id=147a1d92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147a1d92",
  null
  
)

export default component.exports